import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { useTranslation } from 'react-i18next';

export function ProtectedRoute() {
  const { 
    user, 
    loading, 
    isAuthenticated, 
    isDoctor, 
    logout 
  } = useAuth();
  const location = useLocation();
  const { t } = useTranslation('doctor-platform');

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-gray-500" />
      </div>
    );
  }

  // Not authenticated
  if (!isAuthenticated || !user) {
    return <Navigate to="/auth/login" state={{ from: location.pathname }} replace />;
  }

  // Check if user is a doctor (including pending)
  const isDoctorRole = user.role === 'doctor' || user.role === 'doctor_pending';
  
  if (!isDoctorRole) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-2">{t('auth.protectedRoute.accessDenied')}</h2>
          <p className="text-gray-600 mb-4">{t('auth.protectedRoute.doctorOnly')}</p>
          <button
            onClick={async () => {
              await logout();
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            {t('auth.protectedRoute.signOut')}
          </button>
        </div>
      </div>
    );
  }

  // User is authenticated and authorized
  return <Outlet />;
}
